module.exports = __webpack_public_path__ + "static/img/zhaomu.3ff053d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/server/zhaomu.jpg
// module id = yXc+
// module chunks = 171